<template lang="html">
  <div class="container-fluid">
    <div id="mapBoxMap" class="row col-12 mapStyle">

    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import Qs from 'qs'
import axios from "axios";
import loadImage from "blueimp-load-image"
require('mapbox.js')
import 'mapbox-gl/src/css/mapbox-gl.css'
export default {
  name: "SampleBlob",
  data() {
    return {
      mapPoints: [],
      map: {},
      mapToken: "pk.eyJ1IjoicXVpbmVzbGEiLCJhIjoiY2pzOW16NmthMHo4bTQ0bGlic3VjZGtsdyJ9.ggMkRs_gY9KGy3IiPcmkxw",
      accessToken: "",
      generateTokenURL: "https://au1gis.solutions.arcadis.com/arcgis/sharing/rest/generateToken",
      constraintLayerBaseURL: "https://au1gis.solutions.arcadis.com/arcgis/rest/services/CherryFirm/Collector_Base/MapServer/",
      constraintLayers: [],
      featureType: {
        esriGeometryPolygon: "Polygon",
        esriGeometryPolyline: "LineString",
        esriGeometryPoint: "Point"
      },
      baseFeatureLayer: {
        type: "FeatureCollection",
        features: []
      },
      baseFeatureItem: {
        type: "Feature",
        properties: {},
        geometry: {
          type: "",
          coordinates: []
        }
      },
      styles: [
        {color:"#999999", name: "Layout"},
        {color:"#A80000", name: "Line"},
        {color:"#8A1200", name: "Weed pts"},
        {color:"#f2b13a", name: "Homewood rd trees"},
        {color:"#543701", name: "Scattered trees"},
        {color:"#197502", name: "Mature trees"},
        {color:"#ea83cd", name: "Weed pts"},
        {color:"#888888", name: "Ownership", style:"line"},
        {color:"#B8630F", name: "Native veg loss", style:"fill", opacity:0.9},
        {color:"#350FB8", name: "Proposed offset", style:"fill", opacity:0.8},//outline - 00A884
        {color:"#0FB862", name: "Native vegetation", style:"fill", opacity:0.4},
        {color:"#BEFFE8", name: "Blackberry patches (weed)", style:"fill"},
        {color:"#D7B09E", name: "Crown Land", style:"fill"},
      ]
    }
  },
  methods: {
    addConstraintLayers: function() {
      const current = this
      current.constraintLayers.forEach((constraint, index)=>{
        console.log(index);

          console.log(constraint);
          current.map.addSource("constraint"+index, {
            type: "geojson",
            data: constraint
          })
          if (constraint.features[0].geometry.type.includes("Line")) {
            console.log(constraint.features[0].geometry.type);
            console.log("its a line");
            current.map.addLayer({
              id: "LineString"+index,
              type: constraint.features[0].properties.style,
              source: "constraint" + index,
              "layout": {
                "line-join": "round",
                "line-cap": "round"
              },
              "paint": {
                "line-color": constraint.features[0].properties.color,
                "line-width": 2
              }
            })
          }
          else if (constraint.features[0].geometry.type.includes("Point")) {
            console.log(constraint.features[0].geometry.type);

            console.log("its a point");
            current.map.addLayer({
              "id": "Point"+index,
              "type": "circle",
              "source": "constraint" + index,
              "paint": {
                "circle-radius": 4,
                "circle-color": constraint.features[0].properties.color
              }
            })
          }
          else if (constraint.features[0].geometry.type.includes("Polygon")) {
            if (constraint.features[0].properties.style == "fill") {
              var paint = {
                "fill-color":constraint.features[0].properties.color,
                "fill-opacity":constraint.features[0].properties.opacity?constraint.features[0].properties.opacity:0.2
              }
            }
            else {
              var paint = {
                "line-color": constraint.features[0].properties.color,
              }
            }
            console.log(constraint.features[0].geometry.type);
            console.log(constraint.features[0].geometry.coordinates);
            console.log("its a polygon");
            current.map.addLayer({
              "id": "Polygon"+index,
              "type": constraint.features[0].properties.style,
              "source": "constraint" + index,
              "layout": {},
              "paint": paint
            })
          }

      })
    },
    preparePolyLineGeoJson: function(data, index) {
      const current = this
      var constraint = {
        type: "FeatureCollection",
        features: []
      }
      data.features.forEach(feature=>{
        let constraintItem = {
          type: "Feature",
          properties: {
            style: "line",
            color: current.styles[index].color
          },
          geometry: {
            type: (feature.geometry.paths.length > 1)?"MultiLineString":"LineString",
            coordinates: (feature.geometry.paths.length > 1)?feature.geometry.paths:feature.geometry.paths[0]
          }
        }
        constraint.features.push(constraintItem)
      })
      return constraint;
    },
    preparePointGeoJson: function(data, index) {
      const current = this
      var constraint = {
        type: "FeatureCollection",
        features: []
      }
      data.features.forEach(feature=>{
        let constraintItem = {
          type: "Feature",
          properties: {
            style: "circle",
            color: current.styles[index].color
          },
          geometry: {
            type: "Point",
            coordinates: [feature.geometry.x, feature.geometry.y]
          }
        }
        constraint.features.push(constraintItem)
      })
      return constraint
    },
    preparePolygonGeoJson: function(data, index) {
      const current = this
      var constraint = {
        type: "FeatureCollection",
        features: []
      }
      data.features.forEach(feature=>{
        let constraintItem = {
          type: "Feature",
          properties: {
            style: current.styles[index].style,
            color: current.styles[index].color,
            opacity: current.styles[index].opacity?current.styles[index].opacity:0.15
          },
          geometry: {
            type: (feature.geometry.rings.length > 1)?"MultiPolygon":"Polygon",
            coordinates: (feature.geometry.rings.length > 1)?[feature.geometry.rings]:[feature.geometry.rings[0]]
          }
        }
        constraint.features.push(constraintItem)
      })
      return constraint;
    },
  },
  created() {
    const current = this
    var params = {
      username: "Leonardo.Quines_arcadisAU",
      password: "Arcadis1234",
      client: "referer",
      referer: "http://localhost:19001", // should be replaced by state-specific url (dev vs live production)
      f: "json"
    }
    var tokenConfig = {
      url: current.generateTokenURL,
      method: "POST",
      data: Qs.stringify(params),
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true
    }
    axios(tokenConfig).then(result=>{
      if (typeof result.data.error == "undefined") {
        current.isLoggedIn = true
        current.accessToken = result.data.token
        var constraintLayersConfig = {
          url: current.constraintLayerBaseURL+"layers",
          method: "POST",
          data: Qs.stringify({
            token: current.accessToken,
            f: "json"
          }),
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          }
        }
        axios(constraintLayersConfig).then(result=>{
          result.data.layers.map(obj=>obj.id).forEach(layerId=>{
            // if (layerId<2) {
              var layerConfig = {
                url: current.constraintLayerBaseURL+layerId+"/query/",
                method: "POST",
                data: Qs.stringify({
                  token: current.accessToken,
                  f: "json",
                  where: (layerId<2)?"objectid is not null":"FID is not null",
                  outFields: "*",
                  outSR: 4326
                }),
                headers: {
                  'content-type': 'application/x-www-form-urlencoded'
                }
              }
              axios(layerConfig).then(layerResult=>{
                var constraintLayer;
                if (layerResult.data.geometryType == "esriGeometryPolyline") {
                  constraintLayer = current.preparePolyLineGeoJson(layerResult.data, layerId)
                }
                else if (layerResult.data.geometryType == "esriGeometryPoint") {
                  constraintLayer = current.preparePointGeoJson(layerResult.data, layerId)
                }
                else if (layerResult.data.geometryType == "esriGeometryPolygon") {
                  constraintLayer = current.preparePolygonGeoJson(layerResult.data, layerId)
                }
                current.constraintLayers[layerId] = constraintLayer
              })
            // }
            // else {
              // console.log(`Layer ${layerId} not fetched`);
            // }
          })
        })
      }
      else {
        console.log(result.data.error.message)
      }
    })
  },
  mounted() {
    const current = this
    mapboxgl.accessToken = current.mapToken
    current.mapPoints = [
      {
        x: 145.26608542630302,
        y: -37.0632542489332
      }
    ]
    current.map = new mapboxgl.Map({
      container: 'mapBoxMap',
      style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
      center: [151.2093, -39.01], // starting position [lng, lat]
      zoom: 13.5 // starting zoom
    })
    current.map.on("load", function() {

      console.log(current.constraintLayers);
      console.log(current.constraintLayers.length);
      current.addConstraintLayers();
      var mapPoint = {
        "type": "FeatureCollection",
        "features": [{
          "type": "Feature",
          "geometry": {
            "type": "Point",
            "coordinates": [0, 0]
          }
        }]
      }
      current.map.addSource('mapPoint', {
        "type": "geojson",
        "data": mapPoint
      });
      current.map.addLayer({
        "id": "point",
        "type": "circle",
        "source": "mapPoint",
        "paint": {
          "circle-radius": 5,
          "circle-color": "#ff1010"
        }
      })
      console.log(current.constraintLayers);
      current.mapPoints.forEach((point,index)=>{
        setTimeout(function(){
          mapPoint.features[0].geometry.coordinates = [point.x, point.y]
          current.map.getSource('mapPoint').setData(mapPoint);

          current.map.jumpTo({center:[point.x, point.y]})
          console.log("TEST LOG INDEX:"+index);
        }, 5000*index)
      })
    })
    // current.map.on("idle", function(){
    //   current.map.getCanvas().toBlob(blob=>{
    //     var origUrl = URL.createObjectURL(blob)
    //     var origImg = new Image();
    //     origImg.src = origUrl;
    //     origImg.addEventListener("load", function(){
    //       document.getElementById("app").appendChild(origImg)
    //     })
    //
    //     var options = {
    //       orientation: 3,
    //       canvas: true
    //     }
    //     loadImage(blob, function(canvas){
    //       canvas.toBlob(function(rotatedBlob){
    //         console.log(rotatedBlob);
    //         var rotatedUrl = URL.createObjectURL(rotatedBlob)
    //         var rotatedImg = new Image();
    //         rotatedImg.src = rotatedUrl
    //         rotatedImg.addEventListener("load", function(){
    //           document.getElementById("app").appendChild(rotatedImg)
    //         })
    //
    //       })
    //     }, options)
    //   })
    // })
  }
}
</script>

<style lang="css" scoped>
  .mapStyle {
    position: static;
    height: 600px!important;
    visibility: visible;
  }
</style>
